// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = require("../node_modules/html-loader/dist/runtime/getUrl.js");
var ___HTML_LOADER_IMPORT_0___ = require("../images/icons/hashtag-2.svg");
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<div class=\"clearfix\" ng-click=\"context.addFilter(data)\"> <div class=\"suggestion-inner clearfix\"> <div class=\"tag-result pull-left\" title=\"{{ data.value }}\"> <svg-icon src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"></svg-icon> {{ data.value }} </div> <div class=\"count pull-right\">{{ data.count | readableNumber }} Posts</div> </div> </div> ";
// Exports
module.exports = code;